// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"lighthouse-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M8 10V3.6L12 2L16 3.6V10C16 15 18 22 18 22H14L13 18H11L10 22H6C6 22 8 15 8 10Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8 4.1V10C8 15 6 22 6 22H10L11 18H13L14 22H18C18 22 16 15 16 10V4.1M6 11H18M7 4L12 2L17 4","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 6.99805H12.0039V7.00195H12V6.99805Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-lighthouse-1')
export default class Lighthouse1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'lighthouse-1',
    }
  }
}
